export const emailSettingsQueryKeys = {
  _base: () => ["emailSettings"],
  all: (agencyId: string) => [...emailSettingsQueryKeys._base(), { agencyId }],
};
